module.exports = __webpack_public_path__ + "static/media/info-icon.c3351064.svg";